module.exports = "#contentarea\r\n{\r\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n    \r\n}\r\n h3\r\n{\r\n    color:rgb(11,97,174) ;\r\n}\r\n .horizantal-line\r\n{\r\n    background-color: rgb(11,97,174);\r\n    margin-top:20px;\r\n    height:2px;\r\n    margin-bottom:20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/contentarea/contentarea.component.css
// module id = ./src/app/layout/contentarea/contentarea.component.css
// module chunks = main